// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';
import _removePIIFromUgc from './removePIIFromUgc';

const brandEngageSearch = wrapWithNetworkError(function brandEngageSearch(
  token: string,
  {
    clientId,
    channelName,
    brandEngageType,
  }: {
    clientId: Id,
    channelName: string,
    brandEngageType: string,
  }
) {
  const fetchUrl = getEndpointUrl(
    `/brand-engage/${brandEngageType}/client/${clientId}/channel/${channelName}`
  );
  const fetchOptions = {
    headers: {
      Authorization: token,
    },
  };

  return fetch(fetchUrl, fetchOptions)
    .then(response => checkResponse(response))
    .then(response => response.json())
    .then(
      response =>
        Array.isArray(response)
          ? brandEngageType === 'brand'
            ? response.map(brandTransformations)
            : response.map(moveCatalogToUgc)
          : response
    );
});

export default brandEngageSearch;

function brandTransformations(item) {
  return removePIIFromUgc(moveCatalogToUgc(item));
}

function removePIIFromUgc(item: ContentBlob) {
  return {
    ...item,
    ugc: _removePIIFromUgc(item.ugc),
  };
}

function moveCatalogToUgc(item) {
  const { brand_catalog, ...rest } = item;

  const catalog = {
    id: brand_catalog.catalog_id,
    name: brand_catalog.name,
    group_id: brand_catalog.merchant_group.merchant_group_id,
    group_name: brand_catalog.merchant_group.name,
  };

  return {
    ...item,
    ugc: {
      ...rest.ugc,
      catalog: catalog,
    },
  };
}



// WEBPACK FOOTER //
// ./src/containers/brand-engage/brandEngageSearchApi.js